module.exports = __webpack_public_path__ + "img/Background-Main.a527fe8d.jpg";